import React, { useEffect, useRef, useState } from 'react';
import flatpickr from 'flatpickr';
import { formatDateTime, startLoader, stopLoader, validateEmail } from '../../../lib/utils';
// import { createGymEnquiry, updateGymEnquiry } from '../helper/api';
import { isAuthenticated } from '../../../auth';
import Toast from "../../../lib/toast";
import { getUserInfo, getUsersList, getUsersListV2, updateUserV2 } from '../../employees/helper/api';
import {getEnquiryByID} from '../helper/api';
import { getBranch } from '../../gyms/helper/api';
import "../style.scss";

const EditMember = (props) => {

  const birthDateRef = useRef(null);
  const anniversaryDateRef = useRef(null);
  const [userInfo,setUser]=useState("");

  const [currentElementId, setCurrentElementId] = useState("");

  const [userEnqDetails, setUserEnqDetails] = useState({
    officialIDs: {
      panNo: "",
      aadhaarNo: "",
      gstInNo: ""
    },
    name: {
      firstName: "",
      middleName: "",
      lastName: ""
    },
    personalDetails: {
      birthDate: "",
      gender: "",
      maritalStatus: "",
      anniversaryDate: ""
    },
    contactDetails: {
      mobileNumber: "",
      landLineNumber: "",
      emergencyContactPerson: "",
      emergencyContactNumber: "",
      emailAddress: "",
      residentialAddress: "",
      apartmentName: ""
    }
  })


  const [isButtonLock,setButtonLock] = useState(false)
  const { user, token } = isAuthenticated();
  const [Branch,setBranch] = useState("");


  const SaveMember = async event =>{

    const [year, month, day] = userEnqDetails.personalDetails.birthDate.split("-");
    
    try{
      const payload = {
        first_name: userEnqDetails.name.firstName,
        middle_name: userEnqDetails.name.middleName,
        last_name: userEnqDetails.name.lastName,
        name: `${userEnqDetails.name.firstName} ${userEnqDetails.name.middleName} ${userEnqDetails.name.lastName}`.trim(),

        dateofbirthString: userEnqDetails.personalDetails.birthDate,
        ...(year && month && day && {
          dateofbirth: new Date(+year, +month - 1, +day),
        }),
        gender: userEnqDetails.personalDetails.gender,
        maritalStatus: userEnqDetails.personalDetails.maritalStatus,
        anniversaryDateString: userEnqDetails.personalDetails.anniversaryDate,

        phone: userEnqDetails.contactDetails.mobileNumber,
        email: userEnqDetails.contactDetails.emailAddress,
        landline_no: userEnqDetails.contactDetails.landLineNumber,
        emergency_contact_name: userEnqDetails.contactDetails.emergencyContactPerson,
        emergency_contact_no: userEnqDetails.contactDetails.emergencyContactNumber,
        address: {
          residential: userEnqDetails.contactDetails.residentialAddress,
          apartment: userEnqDetails.contactDetails.apartmentName
        },

        pan_number: userEnqDetails.officialIDs.panNo || "",
        gstin_number: userEnqDetails.officialIDs.gstInNo || "",
        aadhar_number: userEnqDetails.officialIDs.aadhaarNo || ""
      
      };
      const response = await updateUserV2(user._id, token, {
        userID: props.member.userId,
        UpdateBody: payload,
        memberId: props.member._id, 
        branchId: props.member.branchId 
      });

      if(!response.error){
        new Toast({
          type:'success',
          message:"Member Saved Successfully",
          duration:3000
        })
        props.reload();
        props.toggleAddMemberModal();
      }else{
        console.log(response);
        new Toast({
          type:'error',
          message:response.error,
          duration:3000
        })
      }
    }catch(error){
      console.log(error);
      new Toast({
        type:'error',
        message:error,
        duration:3000
      })
    }
  }


  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
            element.focus();
            clearInterval(interval)
        }
      }, 0);
    }
  }

  const handleChange = (event) => {
    if(currentElementId == "first-name"){
      setUserEnqDetails(prev => ({
        ...prev,
        name: {
          ...prev.name,
          firstName: event.target.value
        }
      }));
    }
    if(currentElementId == "middle-name"){
      setUserEnqDetails(prev => ({
        ...prev,
        name: {
          ...prev.name,
          middleName: event.target.value
        }
      }));
    }
    if(currentElementId == "last-name"){
      setUserEnqDetails(prev => ({
        ...prev,
        name: {
          ...prev.name,
          lastName: event.target.value
        }
      }));
    }
    if (currentElementId === "mobile-number") {
      const value = event.target.value;

      const numericValue = value.replace(/\D/g, "");

      if (numericValue.length <= 10) {
        setUserEnqDetails(prev => ({
          ...prev,
          contactDetails: {
            ...prev.contactDetails,
            mobileNumber: numericValue
          }
        }));
      }else{
        new Toast({
          type:'warning',
          message:"Phone No. cannot exceed 10 digits",
          duration:3000
        })
      }
    }
    if(currentElementId == "landline-number"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          landLineNumber : event.target.value
        }
      }))
    }
    if(currentElementId == "email-address"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          emailAddress : event.target.value
        }
      }))
    }
   
    if(currentElementId == "residential-address"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          residentialAddress : event.target.value
        }
      }))
    }
 
    if(currentElementId == "apartment-name"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          apartmentName : event.target.value
        }
      }))
    }

    if(currentElementId == "emergency-contact-person"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          emergencyContactPerson : event.target.value
        }
      }))
    }

    if(currentElementId == "emergency-contact-number"){
      setUserEnqDetails(prev => ({
        ...prev,
        contactDetails: {
          ...prev.contactDetails,
          emergencyContactNumber : event.target.value
        }
      }))
    }

    if(currentElementId == "pan-number"){
      setUserEnqDetails(prev => ({
        ...prev,
        officialIDs: {
          ...prev.officialIDs,
          panNo : event.target.value
        }
      }))
    }

    if(currentElementId == "aadhar-number"){
      setUserEnqDetails(prev => ({
        ...prev,
        officialIDs: {
          ...prev.officialIDs,
          aadhaarNo : event.target.value
        }
      }))
    }

    if(currentElementId == "gst-no"){
      setUserEnqDetails(prev => ({
        ...prev,
        officialIDs: {
          ...prev.officialIDs,
          gstInNo : event.target.value
        }
      }))
    }
  }


  const handleRadioAction = (type, value) => {
    if(type == "gender"){
      setUserEnqDetails(prev => ({
        ...prev,
        personalDetails: {
          ...prev.personalDetails,
          gender: value
        }
      }))
    }

    if(type == "marital-status"){
      setUserEnqDetails(prev => ({
        ...prev,
        personalDetails: {
          ...prev.personalDetails,
          maritalStatus: value
        }
      }))
    }
  }

  const getUser = async() => {
    if(props?.member?.user?.[0]?._id || props?.member?.userId){
      
      let userId = props.member.user[0]._id ? props.member.user[0]._id : props.member.userId ? props.member.userId : null;

      if(userId == null){
        new Toast({
          type:'error',
          message:"Member Details Not Found",
          duration:3000
        })

        return;
      }

      try {
        let response = await getUserInfo(user._id, token, userId);
        if (response.error) {
          return;
        }else{
          console.log("Hello user", response)
          setUser(response);
        }
      }catch(err){
        console.log(err);
      }

    }
  }


  useEffect(async () => {

    const birthdayPicker = flatpickr(birthDateRef.current, {
      disableMobile: true,
      dateFormat: "Y-m-d",
      onChange: ([date]) => {
        const istDate = date.toLocaleDateString('en-CA', {
          timeZone: 'Asia/Kolkata'
        });
        setUserEnqDetails(prev => ({
          ...prev,
          personalDetails: {
            ...prev.personalDetails,
            birthDate: istDate
          }
        }));
      }
    });

    const anniversaryDate = flatpickr(anniversaryDateRef.current, {
      dateFormat: "Y-m-d",
      disableMobile: true,
      onChange: ([date]) => {
        const istDate = date.toLocaleDateString('en-CA', {
          timeZone: 'Asia/Kolkata'
        });
        setUserEnqDetails(prev => ({
          ...prev,
          personalDetails: {
            ...prev.personalDetails,
            anniversaryDate: istDate
          }
        }))
      }
    })
  
    return () => {
      birthdayPicker.destroy();
      anniversaryDate.destroy();
    }
  }, []);


  useEffect(() => {
    getUser(props.member);
  },[props.member])

  useEffect(() => {
    if(userInfo){
      setUserEnqDetails({
        name: {
          firstName: userInfo.first_name ? userInfo.first_name.trim() : userInfo.name ||  "",
          middleName: userInfo.middle_name || "",
          lastName: userInfo.last_name || ""
        },
        personalDetails: {
          birthDate: formatDateTime(userInfo.dateofbirth) || "",
          gender: userInfo.gender || "",
          maritalStatus: userInfo.maritalStatus || "",
          anniversaryDate: userInfo.anniversaryDateString || ""
        },
        contactDetails: {
          mobileNumber: userInfo.phone || "",
          landLineNumber: userInfo.landline_no || "",
          emergencyContactPerson: userInfo.emergency_contact_name || "",
          emergencyContactNumber: userInfo.emergency_contact_no || "",
          emailAddress: userInfo.email || "",
          residentialAddress: userInfo.address?.residential || "",
          apartmentName: userInfo.address?.apartment || ""
        },
        officialIDs: {
          panNo: userInfo.pan_number || "",
          gstInNo: userInfo.gstin_number || "",
          aadhaarNo: userInfo.aadhar_number || ""
        }
      });
    }
  }, [userInfo]);
  
  
  // useEffect(() => {
  //   if (!props.selectedUsers) return;

  //   const data = props.selectedUsers;
  //   const userInfo = data.userInfo;

  //   const fetchReferralAndSet = async () => {
  //     let memberEmployeeReferral = "";

  //     if (data.member_employee_referral) {
  //       try {
  //         const getSelectedUser = await getUserInfo(user._id, token, data.member_employee_referral);
  //         if (!getSelectedUser.error) {
  //           memberEmployeeReferral = getSelectedUser;
  //         }
  //       } catch (err) {
  //         console.log(err);
  //       }
  //     }

  //     // Single setUserEnqDetails call — no stale state issue
  //     setUserEnqDetails({
  //       name: {
  //         firstName: userInfo.first_name || "",
  //         middleName: userInfo.middle_name || "",
  //         lastName: userInfo.last_name || ""
  //       },
  //       personalDetails: {
  //         birthDate: userInfo.date_of_birth_string || "",
  //         gender: userInfo.gender || "",
  //         maritalStatus: userInfo.marital_status || "",
  //         anniversaryDate: userInfo.anniversary_date_string || ""
  //       },
  //       contactDetails: {
  //         mobileNumber: userInfo.phone || "",
  //         landLineNumber: userInfo.land_line_number || "",
  //         emergencyContactPerson: userInfo.emergency_contact_person || "",
  //         emergencyContactNumber: userInfo.emergency_contact_no || "",
  //         emailAddress: userInfo.email || "",
  //         residentialAddress: userInfo.residential_address || "",
  //         apartmentName: userInfo.apartment_name || ""
  //       },
  //       personalFitnessStatus: {
  //         healthChallenges: data.health_challenges || "",
  //         fitnessGoal: data.fitness_goal || "",
  //         exercising: data.currently_exercising ?? null
  //       },
  //       gymPrefService: {
  //         gymService: data.gym_service || "",
  //         commitmentDate: data.commitment_date || ""
  //       },
  //       trialBooking: {
  //         trialDateAndTime: "",
  //         assignTo: ""
  //       },
  //       leadAndReferral: {
  //         leadType: data.lead_type || "",
  //         memberEmployeeReferral: memberEmployeeReferral, 
  //         otherReferral: data.other_referral || "",
  //         leadSource: data.lead_source || ""
  //       },
  //       personalTraitAndBudget: {
  //         personalityType: data.personalityType || "",
  //         budget: data.budget || ""
  //       },
  //       remark: data.remark || ""
  //     });
  //   };

  //   fetchReferralAndSet();
  // }, [props.selectedUsers]);


  return(
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="modal-container flex-item" style={{width: window.innerWidth > 767 && "50%", height: window.innerWidth > 767 && "76%"}}>
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <p className="flex-item fs-22 font-weight-600 color-white m-l-5">Edit Member</p>
              <div onClick={props.toggleAddMemberModal} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }

        <div className="w-full m-t-20" style={{height: window.innerWidth > 767 ? "78%" : "100%", padding:"0 16px 100px 16px", overflowY:"auto"}}>

          <div className='d-flex-wrap space-between'>
            <div onClick={toggleInputFields('first-name')} className={`${(currentElementId == 'first-name' || userEnqDetails.name.firstName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'first-name' || userEnqDetails.name.firstName) ? "1px solid #5D883C" : "", width: window.innerWidth > 767 ? "32%" : "100%" }}>
              <div className="flex-item d-flex">
                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'first-name' || userEnqDetails.name.firstName) ? "10px" : "14px", color: (currentElementId == 'first-name' || userEnqDetails.name.firstName) ? "var(--darkBlue)" : "", transition: "180ms" }}>First Name <span className='color-red'>*</span></p>
              </div>
              <input onChange={handleChange} value={userEnqDetails.name.firstName} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'first-name' || userEnqDetails.name.firstName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter First Name' />
            </div>
            <div onClick={toggleInputFields('middle-name')} className={`${(currentElementId == 'middle-name' || userEnqDetails.name.middleName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'middle-name' || userEnqDetails.name.middleName) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "32%" : "100%" }}>
              <div className="flex-item d-flex">
                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'middle-name' || userEnqDetails.name.middleName) ? "10px" : "14px", color: (currentElementId == 'middle-name' || userEnqDetails.name.middleName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Middle Name</p>
              </div>
              <input onChange={handleChange} value={userEnqDetails.name.middleName} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'middle-name' || userEnqDetails.name.middleName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Middle Name'/>
            </div>
            <div onClick={toggleInputFields('last-name')} className={`${(currentElementId == 'last-name' || userEnqDetails.name.lastName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'last-name' || userEnqDetails.name.lastName) ? "1px solid #5D883C" : "", width: window.innerWidth > 767 ? "32%" : "100%" }}>
              <div className="flex-item d-flex">
                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'last-name' || userEnqDetails.name.lastName) ? "10px" : "14px", color: (currentElementId == 'last-name' || userEnqDetails.name.lastName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Last Name</p>
              </div>
              <input onChange={handleChange} value={userEnqDetails.name.lastName} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'last-name' || userEnqDetails.name.lastName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Last Name' />
            </div>
          </div>

          <svg className='m-b-12 m-t-8' width="100%" height="1" viewBox="0 0 785 1" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="0.502441" x2="785.003" y2="0.502441" stroke="#ABABAB" stroke-dasharray="2 2"/>
          </svg>

          <div className='d-flex-wrap w-full space-between'>
            <div className='enq-personal-details-container'>
              <p className='fs-14 font-weight-700 m-b-12'>Personal Details</p>
              <div onClick={toggleInputFields('birth-date')} className={`${(currentElementId == 'birth-date' || userEnqDetails.personalDetails.birthDate) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'birth-date' || userEnqDetails.personalDetails.birthDate) ? "1px solid #5D883C" : "", width: "100%" }}>
                <div className="flex-item d-flex">
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'birth-date' || userEnqDetails.personalDetails.birthDate) ? "10px" : "14px", color: (currentElementId == 'birth-date' || userEnqDetails.personalDetails.birthDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>Birth Date</p>
                </div>
                <input ref={birthDateRef} value={userEnqDetails.personalDetails.birthDate} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'birth-date' || userEnqDetails.personalDetails.birthDate) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD' />
              </div>
              <div className='d-flex m-t-20 m-b-16'>
                <div onClick={()=> handleRadioAction("gender", "Male")} className='d-flex m-r-20'>
                  <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="gender" checked={userEnqDetails.personalDetails.gender == "Male" ? true : false} />
                  <p className='flex-item font-weight-600 color-dark-blue fs-16'>Male</p>
                </div>

                <div onClick={()=> handleRadioAction("gender", "Female")} className='d-flex'>
                  <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="gender" checked={userEnqDetails.personalDetails.gender == "Female" ? true : false} />
                  <p className='flex-item font-weight-600 color-dark-blue fs-16'>Female</p>
                </div>
              </div>
              <div onClick={()=> handleRadioAction("gender", "Others")} className='d-flex'>
                <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="gender" checked={userEnqDetails.personalDetails.gender == "Others" ? true : false} />
                <p className='flex-item font-weight-600 color-dark-blue fs-16'>Others</p>
              </div>
              <p className='fs-14 font-weight-700 m-b-12' style={{marginTop:window.innerWidth > 767 ? "46px" : "26px"}}>Marital Status</p>
              <div className='d-flex m-b-16'>
                <div onClick={()=> handleRadioAction("marital-status", "Single")} className='d-flex m-r-20'>
                  <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="marital-stats" checked={userEnqDetails.personalDetails.maritalStatus == "Single" ? true : false} />
                  <p className='flex-item font-weight-600 color-dark-blue fs-16'>Single</p>
                </div>

                <div onClick={()=> handleRadioAction("marital-status", "Married")} className='d-flex'>
                  <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="marital-stats" checked={userEnqDetails.personalDetails.maritalStatus == "Married" ? true : false} />
                  <p className='flex-item font-weight-600 color-dark-blue fs-16'>Married</p>
                </div>
              </div>
              
              <div onClick={toggleInputFields('anniversary-date')} className={`${(currentElementId == 'anniversary-date' || userEnqDetails.personalDetails.anniversaryDate) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'anniversary-date' || userEnqDetails.personalDetails.anniversaryDate) ? "1px solid var(--darkBlue)" : "", width: "100%", visibility: userEnqDetails.personalDetails.maritalStatus == "Married" ? "visible" : "hidden" }}>
                <div className="flex-item d-flex">
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'anniversary-date' || userEnqDetails.personalDetails.anniversaryDate) ? "10px" : "14px", color: (currentElementId == 'anniversary-date' || userEnqDetails.personalDetails.anniversaryDate) ? "#4d4d4d" : "", transition: "180ms" }}>Anniversary Date</p>
                </div>
                <input ref={anniversaryDateRef} value={userEnqDetails.personalDetails.anniversaryDate} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'anniversary-date' || userEnqDetails.personalDetails.anniversaryDate) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD' />
              </div>
            </div>

            {
              window.innerWidth > 767 ? (
                <svg className='flex-item' width="3" height="350" viewBox="0 0 3 360" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="1.375" y1="360.002" x2="2.4637" y2="0.00355813" stroke="#ABABAB" stroke-dasharray="2 2"/>
                </svg>
              ) : (
                <svg className='m-b-16 m-t-20' width="100%" height="1" viewBox="0 0 785 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line y1="0.502441" x2="785.003" y2="0.502441" stroke="#ABABAB" stroke-dasharray="2 2"/>
                </svg>
              )
            }
            
            <div className='enq-contact-details-container'>
              <p className='fs-14 font-weight-700 m-b-12'>Contact Details</p>
              
              <div className='d-flex-wrap space-between'>
                <div onClick={toggleInputFields('mobile-number')} className={`${(currentElementId == 'mobile-number' || userEnqDetails.contactDetails.mobileNumber) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'mobile-number' || userEnqDetails.contactDetails.mobileNumber) ? "1px solid #5D883C" : "", width: window.innerWidth > 767 ? "48.5%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'mobile-number' || userEnqDetails.contactDetails.mobileNumber) ? "10px" : "14px", color: (currentElementId == 'mobile-number' || userEnqDetails.contactDetails.mobileNumber) ? "var(--darkBlue)" : "", transition: "180ms" }}>Mobile Number <span className='color-red'>*</span></p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.contactDetails.mobileNumber} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'mobile-number' || userEnqDetails.contactDetails.mobileNumber) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder='+91 00000-00000' />
                </div>

                <div onClick={toggleInputFields('landline-number')} className={`${(currentElementId == 'landline-number' || userEnqDetails.contactDetails.landLineNumber) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'landline-number' || userEnqDetails.contactDetails.landLineNumber) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "48.5%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'landline-number' || userEnqDetails.contactDetails.landLineNumber) ? "10px" : "14px", color: (currentElementId == 'landline-number' || userEnqDetails.contactDetails.landLineNumber) ? "var(--darkBlue)" : "", transition: "180ms" }}>Landline Number</p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.contactDetails.landLineNumber} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'landline-number' || userEnqDetails.contactDetails.landLineNumber) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder='+91 00-0000-0000' />
                </div>
              </div>

              <div className='d-flex-wrap space-between'>
                <div onClick={toggleInputFields('emergency-contact-person')} className={`${(currentElementId == 'emergency-contact-person' || userEnqDetails.contactDetails.emergencyContactPerson) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'emergency-contact-person' || userEnqDetails.contactDetails.emergencyContactPerson) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "48.5%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'emergency-contact-person' || userEnqDetails.contactDetails.emergencyContactPerson) ? "10px" : "14px", color: (currentElementId == 'emergency-contact-person' || userEnqDetails.contactDetails.emergencyContactPerson) ? "var(--darkBlue)" : "", transition: "180ms" }}>Emergency Contact Person</p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.contactDetails.emergencyContactPerson} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'emergency-contact-person' || userEnqDetails.contactDetails.emergencyContactPerson) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Name' />
                </div>

                <div onClick={toggleInputFields('emergency-contact-number')} className={`${(currentElementId == 'emergency-contact-number' || userEnqDetails.contactDetails.emergencyContactNumber) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'emergency-contact-number' || userEnqDetails.contactDetails.emergencyContactNumber) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "48.5%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'emergency-contact-number' || userEnqDetails.contactDetails.emergencyContactNumber) ? "10px" : "14px", color: (currentElementId == 'emergency-contact-number' || userEnqDetails.contactDetails.emergencyContactNumber) ? "var(--darkBlue)" : "", transition: "180ms" }}>Emergency Contact Number</p>
                  </div>
                  <input onChange={handleChange} value={userEnqDetails.contactDetails.emergencyContactNumber} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'emergency-contact-number' || userEnqDetails.contactDetails.emergencyContactNumber) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder='+91 00000-00000' />
                </div>
              </div>

              <div onClick={toggleInputFields('email-address')} className={`${(currentElementId == 'email-address' || userEnqDetails.contactDetails.emailAddress) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'email-address' || userEnqDetails.contactDetails.emailAddress) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                <div className="flex-item d-flex">
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'email-address' || userEnqDetails.contactDetails.emailAddress) ? "10px" : "14px", color: (currentElementId == 'email-address' || userEnqDetails.contactDetails.emailAddress) ? "var(--darkBlue)" : "", transition: "180ms" }}>Email Address</p>
                </div>
                <input onChange={handleChange} value={userEnqDetails.contactDetails.emailAddress} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'email-address' || userEnqDetails.contactDetails.emailAddress) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='example@gmail.com' />
              </div>

              <div onClick={toggleInputFields('residential-address')} className={`${(currentElementId == 'residential-address' || userEnqDetails.contactDetails.residentialAddress) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'residential-address' || userEnqDetails.contactDetails.residentialAddress) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                <div className="flex-item d-flex">
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'residential-address' || userEnqDetails.contactDetails.residentialAddress) ? "10px" : "14px", color: (currentElementId == 'residential-address' || userEnqDetails.contactDetails.residentialAddress) ? "var(--darkBlue)" : "", transition: "180ms" }}>Residential Address</p>
                </div>
                <input onChange={handleChange} value={userEnqDetails.contactDetails.residentialAddress} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'residential-address' || userEnqDetails.contactDetails.residentialAddress) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='House/Flat No., Street, Locality, City' />
              </div>

              <div onClick={toggleInputFields('apartment-name')} className={`${(currentElementId == 'apartment-name' || userEnqDetails.contactDetails.apartmentName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'apartment-name' || userEnqDetails.contactDetails.apartmentName) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                <div className="flex-item d-flex">
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'apartment-name' || userEnqDetails.contactDetails.apartmentName) ? "10px" : "14px", color: (currentElementId == 'apartment-name' || userEnqDetails.contactDetails.apartmentName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Apartment / Society Name</p>
                </div>
                <input onChange={handleChange} value={userEnqDetails.contactDetails.apartmentName} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'apartment-name' || userEnqDetails.contactDetails.apartmentName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Your apartment or society (e.g., Rosewood Heights)' />
              </div>

            </div>
              
          </div>

          <svg className='m-b-12 m-t-8' width="100%" height="1" viewBox="0 0 785 1" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="0.502441" x2="785.003" y2="0.502441" stroke="#ABABAB" stroke-dasharray="2 2"/>
          </svg>
          
          {
            userEnqDetails.officialIDs && (
              <div className='w-full'>
                <p className='fs-14 font-weight-700 m-b-12'>Official IDs</p>
                <div className='d-flex-wrap w-full space-between'>
                  <div onClick={toggleInputFields('pan-number')} className={`${(currentElementId == 'pan-number' || userEnqDetails.officialIDs.panNo) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'pan-number' || userEnqDetails.officialIDs.panNo) ? "1px solid #5D883C" : "", width: window.innerWidth > 767 ? "32%" : "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'pan-number' || userEnqDetails.officialIDs.panNo) ? "10px" : "14px", color: (currentElementId == 'pan-number' || userEnqDetails.officialIDs.panNo) ? "var(--darkBlue)" : "", transition: "180ms" }}>PAN Number</p>
                    </div>
                    <input onChange={handleChange} value={userEnqDetails.officialIDs.panNo} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'pan-number' || userEnqDetails.officialIDs.panNo) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Eg. ABCDE1234F' />
                  </div>
                  <div onClick={toggleInputFields('aadhar-number')} className={`${(currentElementId == 'aadhar-number' || userEnqDetails.officialIDs.aadhaarNo) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'aadhar-number' || userEnqDetails.officialIDs.aadhaarNo) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "32%" : "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'aadhar-number' || userEnqDetails.officialIDs.aadhaarNo) ? "10px" : "14px", color: (currentElementId == 'aadhar-number' || userEnqDetails.officialIDs.aadhaarNo) ? "var(--darkBlue)" : "", transition: "180ms" }}>Aadhaar Number</p>
                    </div>
                    <input onChange={handleChange} value={userEnqDetails.officialIDs.aadhaarNo} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'aadhar-number' || userEnqDetails.officialIDs.aadhaarNo) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Eg. 1234 5678 9012'/>
                  </div>
                  <div onClick={toggleInputFields('gst-no')} className={`${(currentElementId == 'gst-no' || userEnqDetails.officialIDs.gstInNo) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'gst-no' || userEnqDetails.officialIDs.gstInNo) ? "1px solid #5D883C" : "", width: window.innerWidth > 767 ? "32%" : "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'gst-no' || userEnqDetails.officialIDs.gstInNo) ? "10px" : "14px", color: (currentElementId == 'gst-no' || userEnqDetails.officialIDs.gstInNo) ? "var(--darkBlue)" : "", transition: "180ms" }}>GSTIN No.</p>
                    </div>
                    <input onChange={handleChange} value={userEnqDetails.officialIDs.gstInNo} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'gst-no' || userEnqDetails.officialIDs.gstInNo) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Eg. 07AAAAA0000A1Z5' />
                  </div>
                </div>
              </div>
            )
          }
        </div>

        <div className="w-full" style={{zIndex:100, position:"absolute", bottom:0, padding:"12px", background : "#f4f4f4", borderRadius:"0 0 20px 20px"}}>
          <div onClick={isButtonLock?null:SaveMember} className={`global-button-container ${isButtonLock?'global-button-container-inactive':'global-button-container-active'} d-flex flex-item`} style={{borderRadius:"20px", height:"40px"}}>
            <p className="flex-item">Update</p>
          </div>
        </div>
    
      </div>
    </div>
  )
}

export default EditMember;